import classNames from 'classnames';
import TextTime from '../TextTime';
import styles from './styles.module.scss';

export type TimeTooltipProps = {
  offsetLeft: number;
  time: number;
};

const TimeTooltip = ({ offsetLeft, time }: TimeTooltipProps) => {
  return (
    <div
      className={classNames(styles.timeTooltipContainer)}
      data-testid='time-tooltip'
      style={{
        left: offsetLeft,
      }}
    >
      <TextTime time={time} className={styles.timeTooltip} />
    </div>
  );
};
export default TimeTooltip;
